import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Header from "./header/page/Header";
import Main from "./main/page/Main";
// import Hero from "./main/component/Hero";
// import Tools from "./main/component/Tools";
// import Marketing from "./main/component/Marketing";
// import AboutUs from "./main/component/AboutUs";
// import ContactUs from "./main/component/ContactUs";
import Footer from "./footer/page/Footer";

import "./App.css";

function App() {
  return (
    <Router>
      <Header />
      <Main />
      <Footer />
    </Router>
  );
}

export default App;
